import { FC, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { Box } from "@mui/material";
import { ColDef } from "ag-grid-community";
import { agGridWrapperStyles } from "@/components/pages/common/ag-grid/utils/constants/agGridStyles";

interface PoorAgGridProps {
  data: any;
  colDefsModifierFn?(colDef: ColDef[]): void;
}

export const PoorAgGrid: FC<PoorAgGridProps> = ({
  data,
  colDefsModifierFn,
}) => {
  const mainWrapperStyles = useMemo(() => {
    return {
      width: "100%",
      height: "100%",
      border: 1,
      borderColor: "grey.400",
      borderRadius: 2,
      overflow: "hidden",
      "& ": { ...agGridWrapperStyles },
    };
  }, []);

  const columnDefs = useMemo(() => {
    return colDefsModifierFn
      ? colDefsModifierFn(data?.columnDefs ?? [])
      : data?.columnDefs;
  }, [data?.columnDefs, colDefsModifierFn]);

  return (
    <Box sx={mainWrapperStyles} className="ag-theme-quartz">
      <AgGridReact
        {...data}
        defaultColDef={{ flex: 1 }}
        columnDefs={columnDefs}
      />
    </Box>
  );
};
